module.exports = __webpack_public_path__ + "media/images/illustrations/corner-3-7df03b547acf315db962f1e2ba85ddd6.png";